import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { Cookie } from 'lucide-react';

export function CookieBanner() {
  const { t } = useTranslation();
  const { hasConsented, acceptAll, rejectNonEssential } = useCookieConsent();
  const location = useLocation();

  // Don't show banner on cookies page or if already consented
  if (hasConsented || location.pathname === '/cookies') {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-300">
      <div className="bg-white border-t border-gray-200 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="flex-shrink-0 w-10 h-10 bg-lime-100 rounded-full flex items-center justify-center">
                <Cookie className="w-5 h-5 text-lime-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">
                  {t('cookies.bannerTitle')}
                </p>
                <p className="text-sm text-gray-600 mt-0.5">
                  {t('cookies.bannerText')}{' '}
                  <Link
                    to="/cookies"
                    className="text-lime-600 hover:text-lime-700 underline"
                  >
                    {t('cookies.learnMore')}
                  </Link>
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3 w-full sm:w-auto">
              <button
                onClick={rejectNonEssential}
                className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors"
              >
                {t('cookies.rejectNonEssential')}
              </button>
              <button
                onClick={acceptAll}
                className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium text-gray-900 bg-lime-400 hover:bg-lime-500 rounded-full transition-colors"
              >
                {t('cookies.acceptAll')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
